import styled from 'styled-components'

export const Wrapper = styled.div`
  margin-bottom: 6rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  @media (max-width: 767px) {
    margin-bottom: 4rem;
  }
`

export const Img = styled.img`
  margin-left: 1rem;
  @media (max-width: 1279px) {
    width: 3rem;
    height: 3rem;
  }

  @media (max-width: 767px) {
    width: 2.5rem;
    height: 2.5rem;
  }
`

export const Title = styled.h2`
  font-size: 4.2rem;
  line-height: 4.8rem;
  font-weight: 400;
  font-family: coolvetica, Arial, Helvetica, sans-serif;
  margin: 0;

  @media (max-width: 1279px) {
    font-size: 3.6rem;
    line-height: 4.2rem;
  }

  @media (max-width: 767px) {
    font-size: 3rem;
    line-height: 3.6rem;
  }
`
